import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Layout, Row, Col } from 'antd';
import { Icon, Modal as ModalMobile } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import * as SignalR from '@aspnet/signalr';
import { Markup } from 'interweave';
import IdleTimer from 'react-idle-timer';

const { Content } = Layout;
const confirmAlert = ModalMobile.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
    'VersionStore',
    'templateStore',
    'CmsLanguageStore',
    'popupStore',
    'loginStore',
    'hotelTvChannelStore',
    'webSettingStore'
)
@observer
class TvChannelPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        const roomNo = this.props.loginStore.getRoomNo();
        if (!roomNo) {
            this.props.history.push('/login');
        };

        this.props.loginStore.authenticateGuest().then(response => {
            if (!response) {
                this.props.history.push('/login');
            }
        });

        this.props.hotelTvChannelStore.getData();

        this.props.CmsLanguageStore.getActives().then(() => {
            this.props.templateStore.getActive().then(() => {
                this.props.webSettingStore.getData().then(() => {
                    const { activeTemplate } = this.props.templateStore;
                    const { data: webSettting } = this.props.webSettingStore;

                    if (webSettting) {
                        this.props.popupStore.getByModuleName('TV_CHANNEL').then(resp => {
                            if (resp) {
                                if (resp.title) {
                                    confirmAlert(
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                            color: activeTemplate.templateSetting.label.color,
                                            fontSize: activeTemplate.templateSetting.label.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                        }}>
                                            <span>{resp.title}</span>
                                        </div>,
                                        <div style={{
                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                            color: activeTemplate.templateSetting.text.color,
                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 8}px`
                                        }}>
                                            <Markup content={resp.description} />
                                        </div>,
                                        [
                                            {
                                                text: <span style={{
                                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                    color: activeTemplate.templateSetting.label.color,
                                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                }}>OK</span>
                                            }
                                        ]);
                                }
                            }
                        });

                    }
                });
            });
        });

        let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
        connection.start().catch(function (err) { return console.error(err.toString()); });
        connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
    }

    back = () => this.props.history.push('/');

    checkSmVersion = () => {
        this.props.VersionStore.check().then(resp => {
            if (!resp) {
                const { activeTemplate } = this.props.templateStore;
                const { data: webSettting } = this.props.webSettingStore;

                confirmAlert(
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.label.fontFamily,
                            color: activeTemplate.templateSetting.label.color,
                            fontSize: activeTemplate.templateSetting.label.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                        }}>
                        <span>Info</span>
                    </div>,
                    <div
                        style={{
                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                            color: activeTemplate.templateSetting.text.color, fontSize: activeTemplate.templateSetting.text.fontSize,
                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`, textAlign: 'center'
                        }}>
                        <span>New version has been released. Please refresh the page.</span>
                    </div>, [
                    {
                        text:
                            <span
                                style={{
                                    fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                    color: activeTemplate.templateSetting.label.color,
                                    fontSize: activeTemplate.templateSetting.label.fontSize,
                                    lineHeight: `${activeTemplate.templateSetting.label.fontSize + 6}px`
                                }}
                            >
                                {webSettting.okText}
                            </span>,
                        onPress: () => {
                            window.location.reload(true);
                        }
                    }
                ]);
            }
        });
    }

    render() {
        const { activeTemplate } = this.props.templateStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            menu,
            items
        } = this.props.hotelTvChannelStore;

        return (
            <>
                {
                    activeTemplate
                        ?
                        <>
                            <Layout className='stm-layout'>
                                <IdleTimer ref={ref => { this.idleTimer = ref }} timeout={1000 * 5} onIdle={this.checkSmVersion} debounce={250} />
                                {
                                    webSettting
                                        ?
                                        <Content>
                                            {/* Header */}
                                            <>
                                                <Row>
                                                    <Col
                                                        span={24}
                                                        className='stm-position-fixed stm-top-0 stm-z-index-100000 stm-max-width-500'
                                                        style={{
                                                            fontFamily: activeTemplate.templateSetting.header.fontFamily,
                                                            background: activeTemplate.templateSetting.header.backgroundColor,
                                                            color: activeTemplate.templateSetting.header.color,
                                                            fontSize: activeTemplate.templateSetting.header.fontSize,
                                                            lineHeight: `${activeTemplate.templateSetting.header.fontSize + 2}px`
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col span={4} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50' onClick={this.back}>
                                                                <Icon type='left' size='lg' color={activeTemplate.templateSetting.header.color} />
                                                            </Col>
                                                            <Col span={16} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-50'>
                                                                {menu ? menu.taskName : ''}
                                                            </Col>
                                                            <Col span={4} />
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </>

                                            {/* Banner */}
                                            <>
                                                {
                                                    menu
                                                        ?
                                                        <>
                                                            {
                                                                menu.bannerUrl === null || menu.bannerUrl === ''
                                                                    ?
                                                                    <Row className='stm-margin-top-50' />
                                                                    :
                                                                    <>
                                                                        <Row className='stm-height-160 stm-margin-top-50 stm-background-size-100-percent'>
                                                                            <Col span={24} className='stm-display-flex stm-align-items-center stm-justify-content-center stm-height-160'>
                                                                                <img src={menu.bannerUrl} alt='Icon' />
                                                                            </Col>
                                                                        </Row>
                                                                    </>
                                                            }
                                                        </>
                                                        :
                                                        null
                                                }
                                            </>

                                            {/* Body */}
                                            <Row className='row-body-content'>
                                                <Col span={1} />
                                                <Col span={22}>
                                                    <Row className='stm-tv-list'>
                                                        <Col
                                                            span={10}
                                                            className=''
                                                            style={{
                                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                color: activeTemplate.templateSetting.label.color,
                                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`,
                                                                fontWeight: 'bold'
                                                            }}
                                                        >
                                                            #
                                                        </Col>
                                                        <Col
                                                            span={14}
                                                            className=''
                                                            style={{
                                                                fontFamily: activeTemplate.templateSetting.label.fontFamily,
                                                                color: activeTemplate.templateSetting.label.color,
                                                                fontSize: activeTemplate.templateSetting.label.fontSize,
                                                                lineHeight: `${activeTemplate.templateSetting.label.fontSize + 2}px`
                                                            }}
                                                        >
                                                            {menu ? menu.taskName : ''}
                                                        </Col>
                                                    </Row>
                                                    <>
                                                        {
                                                            items.map((item) => (
                                                                <Row className='stm-tv-list' key={item.taskId}>
                                                                    <Col
                                                                        span={10}
                                                                        className=''
                                                                        style={{
                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                            color: activeTemplate.templateSetting.text.color,
                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                                        }}
                                                                    >{item.taskName}</Col>
                                                                    <Col
                                                                        span={14}
                                                                        className='stm-tv'
                                                                        style={{
                                                                            fontFamily: activeTemplate.templateSetting.text.fontFamily,
                                                                            color: activeTemplate.templateSetting.text.color,
                                                                            fontSize: activeTemplate.templateSetting.text.fontSize,
                                                                            lineHeight: `${activeTemplate.templateSetting.text.fontSize + 2}px`
                                                                        }}
                                                                    ><Markup content={item.taskDesc} /></Col>
                                                                </Row>
                                                            ))
                                                        }
                                                    </>
                                                </Col>
                                                <Col span={1} />
                                            </Row>
                                        </Content>
                                        :
                                        null
                                }
                            </Layout>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default withTranslation()(TvChannelPage)